<template>
  <div id="app">
    <!-- <div id="trigger1"></div> -->

    <div class="m-nav">
      <button
        class="dropdown-btn hamburger--spin"
        :class="{ 'is-active': showDropdown }"
        @click="handleShowDropdown"
      >
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
      </button>
      <div class="m-to-contact-wrapper">
        <button class="m-to-contact" @click="toRegistration">联系我们</button>
      </div>
    </div>
    <div class="m-dropdown" :class="{ 'dropdown-active': showDropdown }">
      <ul>
        <!-- <li @click="setActive(0, 'm', 'm-news')" :class="{ 'active': activeIndex === 0 }">最新动态</li> -->
        <li @click="setActive(1, 'm','m-guests')" :class="{ 'active': activeIndex === 1 }">参会嘉宾</li>
        <li @click="setActive(2, 'm','m-schedule')" :class="{ 'active': activeIndex === 2 }">活动日程</li>
        <li @click="setActive(3, 'm','m-attraction')" :class="{ 'active': activeIndex === 3 }">活动亮点</li>
        <li @click="setActive(4, 'm','contact')" :class="{ 'active': activeIndex === 4 }">联系我们</li>
      </ul>
    </div>
    <div class="m-dropdown-l" :class="{ 'dropdown-active': showDropdown }">
      <ul>
        <!-- <li @click="setActive(0, 'm', 'news')" :class="{ 'active': activeIndex === 0 }">最新动态</li> -->
        <li @click="setActive(1, 'm', 'guests')" :class="{ 'active': activeIndex === 1 }">参会嘉宾</li>
        <li @click="setActive(2, 'm','schedule')" :class="{ 'active': activeIndex === 2 }">活动日程</li>
        <li @click="setActive(3, 'm','attraction')" :class="{ 'active': activeIndex === 3 }">活动亮点</li>
        <li @click="setActive(4, 'm','contact')" :class="{ 'active': activeIndex === 4 }">联系我们</li>
      </ul>
    </div>
    <div class="nav-wrapper">
      <nav>
        <a href="#" @click="setActive(0, null, null)" :class="{ 'active': activeIndex === 0 }">
          <img src="https://imgcdn.lanxiongsports.com/img/jnh2021/yffx_logo.png" alt />
        </a>
        <ul>
          <!-- <li @click="setActive(0, null, 'news')" :class="{ 'active': activeIndex === 0 }">最新动态</li> -->
          <li @click="setActive(1, null, 'guests')" :class="{ 'active': activeIndex === 1 }">参会嘉宾</li>
          <li @click="setActive(2, null, 'schedule')" :class="{ 'active': activeIndex === 2 }">活动日程</li>
          <li
            @click="setActive(3, null, 'attraction')"
            :class="{ 'active': activeIndex === 3 }"
          >活动亮点</li>
          <li @click="setActive(4, null, 'contact')" :class="{ 'active': activeIndex === 4 }">联系我们</li>
        </ul>
        <div class="nav-event-info">
          <span>2022.01.12</span>
          <button @click="toRegistration">联系我们</button>
        </div>
      </nav>
    </div>
    <section class="video-wrapper">
<!--   <video
        id="lx-video"
        preload="auto"
        :poster="config.poster"
        :src="config.video"
        autoplay
        muted
        loop
        class
      ></video>
      <video
        playsinline="true"
        preload="auto"
        webkit-playsinline="true"
        x5-playsinline="true"
        id="m-video"
        loop="loop"
        :src="config.m_video"
        :poster="config.m_poster"
        :class="{ 'video-hide': isVideoHide }"
        v-show="!isMVideoPlaying"
      ></video>
      <img v-if="isMVideoPlaying" class="video-poster" id="video-poster" :src="config.m_poster" alt />
      <img
        v-if="isMVideoPlaying"
        src="./assets/images/playbtn.png"
        @click="playmVideo"
        id="playbtn"
        alt
      />
-->
<!--
      <div class="banner-wrapper">
        <div class="bottom">
          <div class="slogan-wrapper">
            <p>第五届体育产业嘉年华</p>
            <p>The 5th China Sports Industry Carnival</p>
            <p>2021.01.12 · 上海</p>
          </div>
        </div>
      </div>
      <div class="mask"></div>
      <div v-if="isMVideoPlaying" class="m-mask"></div>
-->
<!--
      <img
        class="live-cover"
        src="https://imgcdn.lanxiongsports.com/img/jnh2021/yffx_top_bg1.png"
        alt=" "
      />
-->

      <img
        class="live-cover"
        src="https://imgcdn.lanxiongsports.com/img/jnh2021/yffx_top_bg_zbhf.png"
        alt="点击观看直播"
        @click="toLive"
      />

    </section>

    <!-- 新闻开始 -->

    <section class="news-wrapper" id="news">
      <h3 class="m-title" id="m-news">
        <i id="m-news-flag" class="m-title-flag"></i>
        <img src="https://imgcdn.lanxiongsports.com/img/jnh2021/m/zxdt.png" alt />
      </h3>
      <div class="section-item-header">
        <div class="label-left">
          <span>最新动态</span>

 <!--       <img src="https://imgcdn.lanxiongsports.com/jnh20/dongtai@2x.png" alt /> -->

        </div>
        <p class="more">
          <a href="http://lanxiongsports.com/search/tags/tagid/18164.html" target="_blank">
            更多
            <img src="https://imgcdn.lanxiongsports.com/jnh20/go2x.png" alt />
          </a>
        </p>
      </div>
      <div id="trigger1"></div>
      <ul class="news-list">
        <li v-for="(item, index) in recentNews" :key="index">
          <a :href="item.link" target="_blank">
            <div class="img-wrapper">
              <img :src="item.imgUrl" alt />
            </div>
            <div class="title">
              <p>{{item.title}}</p>
            </div>
          </a>
        </li>
      </ul>
      <div class="m-more">
        <a href="http://lanxiongsports.com/search/tags/tagid/18164.html">更多</a>
      </div>

      <!-- <h3 class="m-title" id="m-news">
        <i id="m-news-flag" class="m-title-flag"></i>
        <img src="https://imgcdn.lanxiongsports.com/upload/carnival/4th/m_title/latest.png" alt />
      </h3>-->
      <!-- <div class="section-item-header">
        <div class="label-left">
          <span>现场视频</span>
          <img src="https://imgcdn.lanxiongsports.com/upload/carnival/4th/mountain_icon@2x.png" alt />
        </div>

        <p class="more">
          <a href="http://www.lanxiongsports.com/posts/my/uid/60838.html" target="_blank">
            更多
            <img src="https://imgcdn.lanxiongsports.com/upload/carnival/4th/more_icon@2x.png" alt />
          </a>
        </p>
      </div>
      <ul class="news-list">
        <li v-for="(item, index) in videosList" :key="index">
          <a :href="item.link" target="_blank">
            <div class="img-wrapper">
              <img :src="item.imgUrl" alt />
            </div>
            <div class="title">
              <p>{{item.title}}</p>
            </div>
          </a>
        </li>
      </ul>-->
  <!--    <div class="m-more">
        <a href="http://www.runnerbar.com/yd_runnerbar/album/pc?activity_id=17955">更多</a>
      </div>
  -->
 
      <h3 class="m-title" id="m-news">
        <i id="m-news-flag" class="m-title-flag"></i>
        <img src="https://imgcdn.lanxiongsports.com/img/jnh2021/m/album.png" alt />
      </h3>
      <div class="section-item-header">
        <div class="label-left">
          <span>现场图集</span>

<!--         <img src="https://imgcdn.lanxiongsports.com/jnh20/dongtai@2x.png" alt /> -->


        </div>
        <p class="more">
          <a
            href="https://live.photoplus.cn/live/pc/66733549/#/live"
            target="_blank"
          >
            更多
         <img src="https://imgcdn.lanxiongsports.com/jnh20/go2x.png" alt />
          </a>
        </p>
      </div>
      <ul class="news-list">
        <li v-for="(item, index) in album" :key="index">
          <a :href="item.link" target="_blank">
            <div class="img-wrapper">
              <img :src="item.imgUrl" alt />
            </div>
            <div class="title">
              <p>{{item.title}}</p>
            </div>
          </a>
        </li>
      </ul>
      <div class="m-more">
        <a href="https://live.photoplus.cn/live/pc/66733549/#/live">更多</a>
      </div>


    </section>

    <!-- 新闻结束 -->

    <h3 class="m-title" id="m-guests">
      <i id="m-guests-flag" class="m-title-flag"></i>
      <img src="https://imgcdn.lanxiongsports.com/img/jnh2021/m/chjb.png" alt />
    </h3>
    <section class="distinguished-guests hide-news" id="guests">
      <div id="trigger1"></div>

      <ul class="pre-release">
        <li class="animator slideinright" id="guests-slide">
          <div class="content box">
            <img src="https://imgcdn.lanxiongsports.com/img/jnh2021/chjb.png" alt />
          </div>
        </li>
        <li :class="{ 'hide': item.name === '' }" v-for="(item, index) in guests" :key="index">
          <div class="mask"></div>
          <img :src="item.avatar" alt />
          <div class="content">
            <h3>{{item.name}}</h3>
            <pre>{{item.title}}</pre>
          </div>
        </li>
      </ul>
    </section>
    <h3 class="m-title m-schedule-title" id="m-schedule">
      <i id="m-schedule-flag" class="m-title-flag"></i>
      <img src="https://imgcdn.lanxiongsports.com/img/jnh2021/m/hyyc.png" alt />
    </h3>
    <section class="activity-schedule-wrapper" id="schedule">
      <div id="trigger2"></div>
      <div class="activity-schedule">
        <div class="content">
          <div class="room-item">
            <h3>会议议程</h3>
            <ul>
              <li v-for="(item,index) in schedules_.mainVenue" :key="index">
                <div class="item-content">
                  <div class="title-left">{{item.affair.type}}&nbsp;&nbsp;</div>
                  <!-- <div class="title-top">{{item.time}}</div> -->
                  <div class="title-top">
                    <div class="left">{{item.affair.type}}&nbsp;&nbsp;</div>
                    <div class="right">
                      <p>{{item.affair.title}}</p>
                      <!-- <p
                        v-for="(_item_,index) in item.affair.speakers"
                        :key="index"
                        style="font-weight: normal"
                      >{{_item_.title}}丨{{_item_.name}}</p>-->
                    </div>
                  </div>
                  <div class="title-right" v-if="item.affair.title!==''">
                    <p>
                      {{item.affair.title}}
                      <!-- <b
                        v-for="(_item_,index) in item.affair.speakers"
                        :key="index"
                        style="font-weight: normal"
                      >&nbsp;{{_item_.name}}</b>-->
                    </p>
                    <p
                      v-for="(_item, index) in item.affair.speakers"
                      :key="index"
                      style="font-weight: normal"
                    >{{_item.title}}丨{{_item.name}}</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          
          <div class="room-item">
            <h3>价值品牌</h3>
            <ul>
              <li v-for="(item,index) in schedules_.parallelVenue" :key="index">
                <div class="item-content">
                  <div class="title-left">{{item.affair.type}}&nbsp;&nbsp;</div>
          
                  <!-- <div class="title-top">{{item.time}}</div> -->
          
                  <div class="title-top">
                    <div class="left">{{item.affair.type}}&nbsp;&nbsp;</div>
                    <div class="right">
                      <p>{{item.affair.title}}</p>
          
                      <!-- <p
                        v-for="(_item_,index) in item.affair.speakers"
                        :key="index"
                        style="font-weight: normal"
                      >{{_item_.title}}丨{{_item_.name}}</p>-->
                   </div>
                  </div>
                  <div class="title-right" v-if="item.affair.title!==''">
                    <p>
                      {{item.affair.title}}
          
                      <!-- <b
                        v-for="(_item_,index) in item.affair.speakers"
                        :key="index"
                        style="font-weight: normal"
                      >&nbsp;{{_item_.name}}</b>-->
          
                    </p>
                    <p
                      v-for="(_item, index) in item.affair.speakers"
                      :key="index"
                      style="font-weight: normal"
                    >{{_item.title}}丨{{_item.name}}</p>
                  </div>
          
                  <!-- <div class="title-top">
                    <div class="left">{{item.affair.type}}&nbsp;&nbsp;</div>
                    <div class="right">
                      <b>{{item.affair.title}}</b>
                      <b
                        v-for="(_item_,index) in item.affair.speakers"
                        :key="index"
                        style="font-weight: normal"
                      >&nbsp;&nbsp;{{_item_.name}}</b>
                    </div>
                  </div>
                  <div class="title-bottom">
                    <p
                      v-for="(_item, index) in item.affair.speakers"
                      :key="index"
                    >{{ _item.name }}&nbsp;&nbsp;{{_item.title }}</p>
                  </div>
                  <div class="title-right" v-if>
                    <p>
                      {{item.affair.title}}
                      <b
                        v-for="(_item_,index) in item.affair.speakers"
                        :key="index"
                        style="font-weight: normal"
                      >&nbsp;{{_item_.name}}</b>
                    </p>
                    <p
                      v-for="(_item, index) in item.affair"
                      :key="index"
                    >{{ _item.name }}&nbsp;&nbsp;{{_item.title }}</p>
                  </div>-->
        
                </div>
              </li>
            </ul>
          </div>
  <!--
          <div class="room-item">
            <h3>年度颁奖</h3>
            <ul>
              <li>
                <div class="item-content">
                  <div class="title-left">体育产业年度领袖人物&nbsp;&nbsp;</div>
                  <div class="title-top">
                    <div class="left">体育产业年度营销奖&nbsp;&nbsp;</div>
                    <div class="right">
  -->
                      <!-- <b>{{item.affair.title}}</b> -->
                      <!-- <b
                        v-for="(_item_, _index) in item.affair.speakers"
                        :key="_index"
                        style="font-weight: bold"
                      >{{_item_.name}}</b>-->
  
  <!--
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
  -->
          <!-- <div class="room-item">
            <h3>年度颁奖</h3>
            <ul>
              <li v-for="(item,index) in schedules_.awards" :key="index">
                <div class="item-content">
                  <div class="title-left">{{item.affair.type}}&nbsp;&nbsp;</div>
                  <div class="title-top">
                    <div class="left">{{item.affair.type}}&nbsp;&nbsp;</div>
                    <div class="right">
                      <b>{{item.affair.title}}</b>
                      <b
                        v-for="(_item_, _index) in item.affair.speakers"
                        :key="_index"
                        style="font-weight: bold"
                      >{{_item_.name}}</b>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="room-item">
            <h3>Workshop</h3>
            <ul>
              <li v-for="(item,index) in schedules_.workshop" :key="index">
                <div class="item-content">
                  <div class="title-left">{{item.affair.type}}&nbsp;&nbsp;</div>
                  <div class="title-top">
                    <div class="left">{{item.affair.type}}&nbsp;&nbsp;</div>
                    <div class="right">
                      <b>{{item.affair.title}}</b>
                      <b
                        v-for="(_item_, _index) in item.affair.speakers"
                        :key="_index"
                        style="font-weight: bold"
                      >{{_item_.name}}</b>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>-->
          <div id="trigger3"></div>
        </div>
        <div class="title-wrapper animator slidein" id="schedule-slide">
          <div class="title-content box" style="padding-left: 44px;">
            <img src="https://imgcdn.lanxiongsports.com/img/jnh2021/hyyc.png" alt />
          </div>
        </div>
      </div>
    </section>
    <h3 class="m-title m-attraction" id="m-attraction">
      <i id="m-attraction-flag" class="m-title-flag"></i>
      <img src="https://imgcdn.lanxiongsports.com/img/jnh2021/m/hdld.png" alt />
    </h3>
    <section class="attraction" id="attraction">
      <ul>
        <li class="animator slideinright" id="attraction-slide">
          <div class="content box">
            <img src="https://imgcdn.lanxiongsports.com/img/jnh2021/hdld.png" alt />
          </div>
        </li>
        <li>
          <div class="mask"></div>
          <img
            src="https://imgcdn.lanxiongsports.com/img/jnh2021/pics/AX3I5708_w6486.jpg"
            alt
          />
          <div class="content">
            <p>主题分享</p>
          </div>
        </li>
        <li>
          <div class="mask"></div>
          <img
            src="https://imgcdn.lanxiongsports.com/img/jnh2021/pics/kuajieduihua.jpg"
            alt
          />
          <div class="content">
            <p>跨界对话</p>
          </div>
        </li>
        <li>
          <div class="mask"></div>
          <img
            src="https://imgcdn.lanxiongsports.com/img/jnh2021/pics/yuanzhuoluntan.jpg"
            alt
          />
          <div class="content">
            <p>圆桌论坛</p>
          </div>
        </li>
        <li>
          <div class="mask"></div>
          <img src="https://imgcdn.lanxiongsports.com/img/jnh2021/pics/shejiaoqiuju.jpg" alt />
          <div class="content">
            <p>社交球局</p>
          </div>
        </li>
        <li>
          <div class="mask"></div>
          <img
            src="https://imgcdn.lanxiongsports.com/img/jnh2021/pics/xmzs.jpg"
            alt
          />
          <div class="content">
            <p>项目展示</p>
          </div>
        </li>
        <li>
          <div class="mask"></div>
          <img src="https://imgcdn.lanxiongsports.com/img/jnh2021/pics/swqt.jpg" alt />
          <div class="content">
            <p>商务洽谈</p>
          </div>
        </li>
      </ul>
    </section>
  
    <section class="logos-wrapper">
      <h3 class="m-title">主办方</h3>
      <div class="section-item-header">
        <div class="label-left">
          <span>主办方</span>
  
          <!-- <img src="./assets/images/general_title_icon.png" alt /> -->
        </div>
        <i class="line"></i>
      </div>
      <div class="logos-content m-lxlogo">
        <ul class="sponsor">
          <li></li>
          <li>
            <img src="https://imgcdn.lanxiongsports.com/jnh20/media/lx_logo.jpg" alt />
          </li>
        </ul>
      </div>
<!--
     <h3 class="m-title">品牌合作伙伴</h3>
       <div class="section-item-header">
        <div class="label-left">
          <span>品牌合作伙伴</span>
        </div>
        <i class="line"></i>
      </div>
      <div class="logos-content sponsor-medias">
        <ul class="sponsor media">
          <li></li>
          <li>
            <img src="http://imgcdn.lanxiongsports.com/upload/carnival/media_brand_1.png" alt />
          </li>
          <li>
            <img src="http://imgcdn.lanxiongsports.com/upload/carnival/media_brand_2.png" alt />
          </li>
          <li>
            <img src="http://imgcdn.lanxiongsports.com/upload/carnival/media_brand_3.png" alt />
          </li>
          <li>
            <img src="http://imgcdn.lanxiongsports.com/upload/carnival/media_brand_4.png" alt />
          </li>
        </ul>
        <ul class="sponsor media">
          <li></li>
          <li>
            <img src="http://imgcdn.lanxiongsports.com/upload/carnival/media_brand_6.png" alt />
          </li>
          <li>
            <img src="http://imgcdn.lanxiongsports.com/upload/carnival/media_brand_7.png" alt />
          </li>
          <li>
            <img src="http://imgcdn.lanxiongsports.com/upload/carnival/media_brand_8.png" alt />
          </li>
          <li>
            <img src="http://imgcdn.lanxiongsports.com/upload/carnival/media_final.png" alt />
          </li>
        </ul>
        <ul class="m-media">
          <li>
            <img src="http://imgcdn.lanxiongsports.com/upload/carnival/media_brand_1.png" alt />
          </li>
          <li>
            <img src="http://imgcdn.lanxiongsports.com/upload/carnival/media_brand_2.png" alt />
          </li>
          <li>
            <img src="http://imgcdn.lanxiongsports.com/upload/carnival/media_brand_3.png" alt />
          </li>
          <li>
            <img src="http://imgcdn.lanxiongsports.com/upload/carnival/media_brand_4.png" alt />
          </li>
          <li>
            <img src="http://imgcdn.lanxiongsports.com/upload/carnival/media_brand_6.png" alt />
          </li>
          <li>
            <img src="http://imgcdn.lanxiongsports.com/upload/carnival/media_brand_7.png" alt />
          </li>
          <li>
            <img src="http://imgcdn.lanxiongsports.com/upload/carnival/media_brand_8.png" alt />
          </li>
          <li>
            <img src="http://imgcdn.lanxiongsports.com/upload/carnival/media_final.png" alt />
          </li>
        </ul>
      </div>
-->
<!--
      <h3 class="m-title">合作伙伴</h3> 
      
      <div class="section-item-header">
        <div class="label-left">
          <span>合作伙伴</span>
        </div>
        <i class="line"></i>
      </div>
      <ul class="partner-logos">
        <li>
          <p class="m-title" style="display:flex;">独家新媒体视频合作伙伴</p>
          <img src="http://imgcdn.lanxiongsports.com/jnh20/media/pptv.jpg" alt />
        </li>
        <li>
          <p class="m-title" style="display:flex;">会务独家合作伙伴</p>
          <img src="http://imgcdn.lanxiongsports.com/jnh20/media/dtk.jpg" alt />
        </li>
-->
<!--
        <li>
          <p class="m-title" style="display:flex;">独家图片合作机构</p>
          <img src="http://imgcdn.lanxiongsports.com/upload/carnival/4th/media/icphoto.jpg" alt />
        </li>
      </ul>
-->

      <h3 class="m-title" style>合作媒体</h3>
      <div class="section-item-header">
        <div class="label-left">
          <span>合作媒体</span>
  
 <!--     <img src="./assets/images/general_title_icon.png" alt /> -->
       
   
        </div>
        <i class="line"></i>
      </div>
      <div class="logos-content">
        <ul class="m-media">
          <li>
            <img
              src="https://imgcdn.lanxiongsports.com/img/jnh2021/media/36kr.png"
              alt />
          </li>
          <li>
            <img src="https://imgcdn.lanxiongsports.com/img/jnh2021/media/jm.png" alt />
          </li>
          <li>
            <img
              src="https://imgcdn.lanxiongsports.com/img/jnh2021/media/tmt.png" alt />
          </li>
        </ul>
        <ul class="m-media">
          <li>
            <img src="https://imgcdn.lanxiongsports.com/img/jnh2021/media/tzj.png" alt />
          </li>

          <li>
            <img src="https://imgcdn.lanxiongsports.com/img/jnh2021/media/ljcj.png" alt />
          </li>
           <li>
            <img
              src="https://imgcdn.lanxiongsports.com/img/jnh2021/media/sina.png"
              alt
            />
          </li>
        </ul>
        <ul class="m-media">

          <li>
            <img src="https://imgcdn.lanxiongsports.com/img/jnh2021/media/hdx.png" alt />
          </li>
          <li>
            <img
              src="https://imgcdn.lanxiongsports.com/img/jnh2021/media/donews.png" alt />
          </li>
          <li>
            <img
              src="https://imgcdn.lanxiongsports.com/img/jnh2021/media/bjh.png"
              alt
            />
          </li>
        </ul>
        <ul class="m-media">
          <li>
            <img src="https://imgcdn.lanxiongsports.com/img/jnh2021/media/dy.png" alt />
          </li>
          <li>
            <img
              src="https://imgcdn.lanxiongsports.com/img/jnh2021/media/xy.png"
              alt
            />
          </li>
          <li>
            <img
              src="https://imgcdn.lanxiongsports.com/img/jnh2021/media/pj.png"
              alt
            />
          </li>
        </ul>

        <ul class="media">
          <li> </li>

         <li>
            <img
              src="https://imgcdn.lanxiongsports.com/img/jnh2021/media/36kr.png"
              alt
            />
          </li>
          <li>
            <img src="https://imgcdn.lanxiongsports.com/img/jnh2021/media/jm.png" alt />
          </li>
          <li>
            <img src="https://imgcdn.lanxiongsports.com/img/jnh2021/media/tmt.png" alt />
          </li>

        </ul>
        <ul class="media">
          <li> </li>

         <li>
            <img
              src="https://imgcdn.lanxiongsports.com/img/jnh2021/media/tzj.png"
              alt
            />
          </li>
          <li>
            <img src="https://imgcdn.lanxiongsports.com/img/jnh2021/media/ljcj.png" alt />
          </li>
          <li>
            <img src="https://imgcdn.lanxiongsports.com/img/jnh2021/media/sina.png" alt />
          </li>

        </ul>

        <ul class="media">
          <li> </li>

         <li>
            <img
              src="https://imgcdn.lanxiongsports.com/img/jnh2021/media/hdx.png"
              alt
            />
          </li>
          <li>
            <img src="https://imgcdn.lanxiongsports.com/img/jnh2021/media/donews.png" alt />
          </li>
          <li>
            <img src="https://imgcdn.lanxiongsports.com/img/jnh2021/media/bjh.png" alt />
          </li>

        </ul>
        <ul class="media">
          <li> </li>

         <li>
            <img
              src="https://imgcdn.lanxiongsports.com/img/jnh2021/media/dy.png"
              alt
            />
          </li>
          <li>
            <img src="https://imgcdn.lanxiongsports.com/img/jnh2021/media/xy.png" alt />
          </li>
          <li>
            <img src="https://imgcdn.lanxiongsports.com/img/jnh2021/media/pj.png" alt />
          </li>

        </ul>
     </div>

    </section>
    
    <section class="activity-info">
      <div class="content">
        <h3 class="m-title">
          <img src="https://imgcdn.lanxiongsports.com/img/jnh2021/m/hdsj.png" alt />
        </h3>
        <p>
          <span>活动时间：</span>2022年1月12日
        </p>

        <h3 class="m-title">
          <img src="https://imgcdn.lanxiongsports.com/img/jnh2021/m/hddd.png" alt />
        </h3>
        <p>
          <span>活动地点：</span>上海
        </p>

      </div>
    </section>
    <footer id="contact">
      <i class="m-title-flag" id="contact-flag"></i>
      <div class="qrcode-imgs-wrapper">
        <ul>
          <li>
            <img src="https://imgcdn.lanxiongsports.com/img/jnh2021/yffx_qrcode.png" alt />
            <p>
              <span>活</span>
              <span>动</span>
              <span>报</span>
              <span>名</span>
            </p>
          </li>
          <li>
            <img src="http://imgcdn.lanxiongsports.com/upload/lx-service/qrcode_sw.jpg" alt />
            <p>
              <span>商</span>
              <span>务</span>
              <span>合</span>
              <span>作</span>
            </p>
          </li>
        </ul>
      </div>
      <p class="copyright">© 懒熊体育 版权所有 复制必究 京ICP备15019109号-2</p>
    </footer>
  </div>
</template>

<script>
import axios from 'axios';
import qs from 'qs';
import request from './utils/request';
import ScrollMagic from 'scrollmagic';
import data from './data';
import smoothscroll from 'smoothscroll-polyfill';

const { guests, schedules, recentNews, videosList, album } = data;

smoothscroll.polyfill();

export default {
  name: 'app',
  data() {
    return {
      isWeixinBrowser: false,
      activeIndex: null,
      isMVideoPlaying: true,
      showDropdown: false,
      isVideoHide: false,
      guests,
      schedules,
      recentNews,
      videosList,
      album,
      schedules_: schedules,
      config: {
        video: 'http://videocdn.lanxiongsports.com/jnh/PC_1114.mp4',
        m_video: 'http://videocdn.lanxiongsports.com/jnh/m_1114.mp4',
        poster: 'https://imgcdn.lanxiongsports.com/img/jnh2021/yffx_top_bg1.png',
        m_poster:
          'https://imgcdn.lanxiongsports.com/img/jnh2021/m_top_bg.png',
        shareIcon:
          'https://imgcdn.lanxiongsports.com/img/jnh2021/thumb_180.jpg',
      },
    };
  },
  created() {
    this.isWeixinBrowser = this.testWeixinBrowser();
  },
  mounted() {
    const controller = new ScrollMagic.Controller();
    const scene1 = new ScrollMagic.Scene({
      triggerElement: '#trigger1',
      offset: -450,
    })
      // const scene1 = new ScrollMagic.Scene({
      //   triggerElement: '#trigger1',
      //   offset: 0,
      // })
      .setClassToggle('#guests-slide', 'anim-clear')
      .addTo(controller);
    scene1.reverse(false);
    const scene2 = new ScrollMagic.Scene({
      triggerElement: '#trigger2',
      offset: -250,
    })
      .setClassToggle('#schedule-slide', 'anim-clear')
      .addTo(controller);
    scene2.reverse(false);
    const scene3 = new ScrollMagic.Scene({
      triggerElement: '#trigger3',
      offset: -280,
    })
      .setClassToggle('#attraction-slide', 'anim-clear')
      .addTo(controller);
    scene3.reverse(false);

    request
      .post('/wx/getTicketSign.do', {
        url: window.location.href.split('#')[0],
      })
      .then(res => {
        window.wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: 'wx4690a55401737a1f', // 必填，公众号的唯一标识
          timestamp: res.timestamp, // 必填，生成签名z 的时间戳
          nonceStr: res.nonceStr, // 必填，生成签名的随机串
          signature: res.signature, // 必填，签名
          jsApiList: [
            'onMenuShareAppMessage',
            'onMenuShareTimeline',
            'scanQRCode',
            'chooseWXPay',
          ], // 必填，需要使用的JS接口列表
        });
        window.wx.ready(() => {
          const link = window.location.href;
          const timeLineConf = {
            title: '御风飞翔-第六届体育产业嘉年华', // 分享标题
            link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: this.config.shareIcon, // 分享图标
            success: function() {
              // 用户点击了分享后执行的回调函数  
            },
          };

          const friendsConf = {
            title: '御风飞翔-第六届体育产业嘉年华', // 分享标题
            // desc: this.actinav_logovityDetail.lecturerInfo.intro, // 分享描述
            link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: this.config.shareIcon, // 分享图标
            desc: '2022.1.12，上海',
            success: function() {
              // 用户点击了分享后执行的回调函数
            },
          };
          window.wx.onMenuShareTimeline(timeLineConf);
          window.wx.onMenuShareAppMessage(friendsConf);
        });
      });
  },
  methods: {
    setActive(index, from = null, id) {
      this.activeIndex = index;
      if (from === 'm') {
        this.showDropdown = false;
        setTimeout(() => {
          this.isVideoHide = !this.isVideoHide;
        }, 300);
        const elm = document.getElementById(`${id}-flag`);
        if (elm) {
          elm.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        const elm = document.getElementById(id);

        if (elm) {
          elm.scrollIntoView({ behavior: 'smooth' });
        }
      }
    },
    playmVideo() {
      this.isMVideoPlaying = false;
      document.getElementById('m-video').play();
    },
    handleShowDropdown() {
      this.showDropdown = !this.showDropdown;
      setTimeout(() => {
        this.isVideoHide = !this.isVideoHide;
      }, 300);
    },
    testWeixinBrowser() {
      const ua = window.navigator.userAgent.toLowerCase();
      return ua.includes('micromessenger') && !ua.includes('windowswechat');
    },
    toRegistration() {
       if (this.isWeixinBrowser) {
         window.location.href =
           'http://service.lanxiongsports.com/services/';
      } else {
      window.open('http://service.lanxiongsports.com/services/');
      }
    },
    toLive() {
      window.open(
        'https://weibo.com/l/wblive/p/show/1022:2321324724612461363418'
      );
    }, 
  },
};
</script>

<style lang="scss" src="./App.scss">
</style>
